export default "__VITE_ASSET__9NTADM$S__"